exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected[data-v-3710a151]{background-color:#00c0ff!important}.dialog_tab[data-v-3710a151]{width:34px;z-index:99}.dialog_tab_button[data-v-3710a151]{background-color:rgba(0,116,201,.8);margin-top:2px;height:34px;line-height:34px}.dialog_tab_button_left[data-v-3710a151]{border-radius:2px 5px 5px 2px}.dialog_tab_button_right[data-v-3710a151]{border-radius:5px 2px 2px 5px}.dialog_tab_right[data-v-3710a151]{right:0}.icon_right[data-v-3710a151]{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}", ""]);

// exports
